const doc = [({"se":({"js":({"routes":({"play":({"welcome":({"enter_code_to_begin":"Ange kod för att börja "})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;